import CheckoutDatalayer from '@curry/checkout'

export default class CheckoutApi {
  constructor({ config, transports }) {
    this.datalayer = new CheckoutDatalayer({ config, transports });
  }

  view({ order_id }) {
    return new Promise((resolve, reject) => {
      const args = { order_id };
      
      this.datalayer.models[0].findById({ args })
      .then((response) => {
        resolve(response.data);
      }).catch(reject); 
    });
  }

  post({ cart }) {
    return new Promise((resolve, reject) => {
      cart.queue.trigger().then((c) => {
        const item = { 
          cart_id: cart.id,
          service: cart.service
        }
        
        this.datalayer.models[0].save({ item }).then((order) => {
          resolve({order: order.data, cart: c});
        }).catch(reject); 
      }).catch((er) => {
        console.error(er);
        reject(er);
      });
    });
  }

  reset({ orderId }) {
    return new Promise((resolve, reject) => {
      const args = { order_id: orderId };
      
      this.datalayer.models[0].update({args})
      .then((response) => {
        resolve(response.data);
      }).catch(reject)
    })
  }
}